document.querySelectorAll('.shopify-section.section-page-banner').forEach(section => {
  if (section.querySelector('.section-height--50svh')) {
    section.classList.add('h-half')
  }
});

document.querySelectorAll('.testimonial__rating .icon svg').forEach(svg => {
  svg.outerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
      <path d="M2.55 12.6667L3.63333 7.98333L0 4.83333L4.8 4.41667L6.66667 0L8.53333 4.41667L13.3333 4.83333L9.7 7.98333L10.7833 12.6667L6.66667 10.1833L2.55 12.6667Z" fill="currentColor" stroke-width=".7px" />
    </svg>
  `;
});

(function () {
  const el = document.querySelector('.article .article__share.article__share--sticky')
  if (!el) return

  const updateHeight = () => {
    const h = el.offsetHeight
    document.documentElement.style.setProperty('--social-share-sticky-height', `${h}px`)
  }

  updateHeight()
  window.addEventListener('resize', updateHeight)
})()